"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderLogo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("../../context");
const react_1 = require("react");
const HeaderLogo = () => {
    const { firstLineData: { homePageUrl }, } = (0, react_1.useContext)(context_1.HeaderContext);
    return ((0, jsx_runtime_1.jsx)("a", { className: "w-fit", href: homePageUrl, children: (0, jsx_runtime_1.jsx)("img", { className: "xs:h-[48px] xs:w-[110px] xs:min-h-[48px] xs:min-w-[110px] h-[44px] min-h-[44px] w-[101px] min-w-[101px]", src: "/static/images/new-logo.svg", alt: "Danfoss" }) }));
};
exports.HeaderLogo = HeaderLogo;
